import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';

const CarPublishedEmail = ({ content }) => {
  const { userName, carTitle, carId, logo, siteName } = content || {};
  const textStyle = {
    color: '#484848',
    backgroundColor: '#F7F7F7',
    fontFamily: 'Arial',
    fontSize: '16px',
    padding: '35px'
  };
  return (
    <Layout>
      <Header
        color="rgb(255, 90, 95)"
        backgroundColor="#F7F7F7"
        logo={logo}
        siteName={siteName}
      />
      <Body textStyle={textStyle}>
        <div>
          <h2>Your Car Listing Has Been Published!</h2>
          <p>Hi {userName || 'User'},</p>
          <p>
            Congratulations! Your car listing <strong>{carTitle || 'Car'}</strong> (ID: {carId}) has been reviewed and published on our platform.
          </p>
          <p>
            You can now view your listing live and start receiving bookings.
          </p>
          <p>
            Thank you for choosing us!
          </p>
        </div>
        <EmptySpace height={30} />
      </Body>
      <Footer siteName={siteName} />
      <EmptySpace height={20} />
    </Layout>
  );
};

export default CarPublishedEmail;